/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1TutoraiConfigPersonaQueryResponse,
  GetApiV1TutoraiConfigPersonaQueryParams,
  GetApiV1TutoraiConfigPersona401,
  GetApiV1TutoraiConfigPersona500,
} from "../../types/tutorAIConfigController/GetApiV1TutoraiConfigPersona.ts";

function getGetApiV1TutoraiConfigPersonaUrl() {
  const res = { method: "GET", url: `/api/v1/tutorai/config/persona` as const };
  return res;
}

/**
 * @description Retorna o system prompt configurado. Se `classStudentId` for informado, retorna a persona específica da turma com fallback para a global. `content` é `null` quando não configurada. **(Requer Authorization para autenticação)**
 * @summary Obter persona do assistente (Requer Authorization para autenticação)
 * {@link /api/v1/tutorai/config/persona}
 */
export async function getApiV1TutoraiConfigPersona(
  params?: GetApiV1TutoraiConfigPersonaQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1TutoraiConfigPersonaQueryResponse,
    ResponseErrorConfig<
      GetApiV1TutoraiConfigPersona401 | GetApiV1TutoraiConfigPersona500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1TutoraiConfigPersonaUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
